

// const baseURL = "http://46.37.122.105:81/"; 

// const baseURL = "http://localhost:5001"; 

const baseURL = "https://erp.newfriendsjewellers.com:8080";


export default baseURL;